import React from "react";
import PortfolioItem from "./PortfolioItem";
import p01 from "../../../images/portfolio/project-01.jpg";
import p02 from "../../../images/portfolio/project-02.jpg";
import p03 from "../../../images/portfolio/project-03.jpg";
import p04 from "../../../images/portfolio/project-04.jpg";
import p05 from "../../../images/portfolio/project-05.jpg";
import p06 from "../../../images/portfolio/project-06.jpg";

const portfolioData = [
  {
    id: 1,
    image: p01,
    title: "IRC Server",
    link: "https://github.com/istili/IRC-SERVER",
    description:
      "Full C++ network server implementing IRC protocol. Features multi-client handling, socket programming, and real-time communication. Demonstrates advanced C++ and network programming skills.",
  },
  {
    id: 2,
    image: p02,
    title: "Minishell - Custom Unix Shell",
    link: "https://github.com/istili/minishell",
    description:
      "Bash-like shell interpreter built in C. Implements parsing, command execution, pipes, redirections, and environment variable handling. Core 42 project showcasing system programming expertise.",
  },
  {
    id: 3,
    image: p03,
    title: "Push Swap - Sorting Algorithm",
    link: "https://github.com/istili/push_swap",
    description:
      "Efficient sorting algorithm implementation in C. Optimizes stack operations with minimal moves. Demonstrates algorithm design, data structures, and optimization skills.",
  },
  {
    id: 4,
    image: p04,
    title: "So Long - 2D Game Graphics",
    link: "https://github.com/istili/so_long",
    description:
      "2D game built with C and graphics library (minilibx). Features collision detection, sprite rendering, and game state management. Shows graphics programming and systems thinking.",
  },
  {
    id: 5,
    image: p05,
    title: "inception - Container Orchestration",
    link: "https://github.com/istili/inception",
    description:
      "Container orchestration project using Docker. Implements microservices architecture with multiple containers for web server, database, and application logic. Demonstrates DevOps skills and containerization expertise.",
  },
  {
    id: 6,
    image: p06,
    title: "ft_transcendence - Full-Stack Web Application",
    link: "https://github.com/istili/ft_transcendence",
    description:
      "Full-stack web application built with React and Node.js. Features user authentication, real-time communication, and responsive design. Demonstrates modern web development practices and team collaboration.",
  },
];

const Portfolio = () => {
  return (
    <section className="py-0">
      <div className="flex flex-wrap w-full -mx-1.5">
        {portfolioData.map((portfolio, id) => (
          <PortfolioItem portfolio={portfolio} key={id} />
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
